import classNames from "classnames";

import { CCard, CCardBody } from "@coreui/react";

import { usePermissionCheck } from "src/1/common/components/others";
import { CActionGroup } from "src/common/components/others";
import { ENTITY_GROUP_CODE, PERMISSION_VALUE } from "src/configs/constant";
import { useMobileDevice } from "src/utils/hooks/viewport";

export const WarehouseToolbar = ({
  onAdd,
  onEdit,
  onRemove,
  canRemove,
  canEdit,
}) => {
  //#region Data
  const checkPermission = usePermissionCheck();

  const isMobile = useMobileDevice();
  //#endregion

  //#region Event
  const onClick = (key) => {
    switch (key) {
      case "add":
        return onAdd();
      case "edit":
        return onEdit();
      case "remove":
        return onRemove();
      default:
        return onAdd();
    }
  };
  //#endregion

  //#region Render
  return (
    <CCard className={classNames("toolbar", !isMobile && "sticky")}>
      <CCardBody>
        <div>
          <CActionGroup
            onClick={onClick}
            canAdd={checkPermission({
              [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.CREATE,
            })}
            canEdit={
              canEdit &&
              checkPermission({
                [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.UPDATE,
              })
            }
            canRemove={
              canRemove &&
              checkPermission({
                [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.DELETE,
              })
            }
          />
        </div>
      </CCardBody>
    </CCard>
  );
  //#endregion
};
